import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: calc(100% - 40px);
  position: absolute;
  top: 30vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface IPassProps {
  active: boolean;
  isComplete: boolean;
}

export const Pass = styled.div<IPassProps>`
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  border: ${({ isComplete }) =>
    isComplete ? `2px solid ${theme.colors.blue400}` : "none"};
  align-items: center;
  font-family: Poppins;
  font-size: ${theme.font.sizes.normal};
  background-color: ${({ active }) =>
    active ? theme.colors.blue400 : theme.colors.blue900};
  color: ${({ active, isComplete }) => {
    if (isComplete) return theme.colors.blue400;
    return active ? theme.colors.white : theme.colors.gray600;
  }};
`;

export const Dash = styled.div<Pick<IPassProps, "isComplete">>`
  height: 2px;
  width: 16px;
  background-color: ${({ isComplete }) =>
    isComplete ? theme.colors.blue400 : theme.colors.gray600};
`;
